import classNames from 'classnames/bind';
import React from 'react';

import styles from './SlidingPanel.module.scss';

const cx = classNames.bind(styles);

const SlidingPanel = ({ active, origin, className, style, children }) => {
  return (
    <div
      className={cx(['panel', origin, className])}
      data-active={active || undefined}
      inert={!active ? '' : undefined}
      style={style}>
      {children}
    </div>
  );
};

export default SlidingPanel;
